import Image from 'next/image';
import { TeamMemberListStyles } from '../../styles/components/team-members';

export interface ITeamMemberListItem {
  fullname: string;
  jobTitle: string;
  avatarUrl: string;
  slug: string;
}

export interface ITeamMemberListProps {
  title: string;
  subTitle: string;
  teamMembers: ITeamMemberListItem[];
}

export const TeamMemberList = (props: ITeamMemberListProps) => {
  return (
    <div className={TeamMemberListStyles['team-member-list']}>
      <h2 className={TeamMemberListStyles['team-member-list-title']}>
        {props.title}
      </h2>
      <p className={TeamMemberListStyles['team-member-list-subtitle']}>
        {props.subTitle}
      </p>
      <div className={TeamMemberListStyles['team-member-list-items']}>
        {props.teamMembers.map((member) => (
          <a
            key={member.slug}
            className={TeamMemberListStyles['team-member-list-item']}
            href={`${member.slug}`}>
            <Image
              src={member.avatarUrl}
              alt={member.fullname}
              className={TeamMemberListStyles['team-member-list-item-avatar']}
              width={400}
              height={400}
            />
            <p className={TeamMemberListStyles['team-member-list-item-name']}>
              {member.fullname}
            </p>
            <p
              className={
                TeamMemberListStyles['team-member-list-item-job-title']
              }>
              {member.jobTitle}
            </p>
          </a>
        ))}
      </div>
    </div>
  );
};
